import { get, post, httpDelete } from './APIHelper';

export const getUserAccess = async () => {
  return get('user/access');
};

export const getUserProfile = async () => {
  return get('user/me');
};

export const updateUserProfile = async payload => {
  return post('user/me', payload);
};

export const deleteMyAccount = async () => {
  return httpDelete('user/me');
};
